import { Box } from "@mui/material";
import SectionCollapsible from "../../../common/SectionCollapsible";
import SectionFields from "../tabs/common/Section/SectionFields";
import { buildScoresFields } from "../fields/scores";
import type { Pillars } from "../../types";

export function ReadOnlyScoresContainer({ pillars }: { pillars?: Pillars }) {
  return (
    <Box data-testid="read-only-scores-container">
      <SectionCollapsible label="Scores">
        <SectionFields
          fields={buildScoresFields(pillars)}
          columns={2}
          fieldIdPrefix="read-only-scores"
          highlightMissingFields={false}
        />
      </SectionCollapsible>
    </Box>
  );
}

export default ReadOnlyScoresContainer;
